import { render } from "./CloseX.vue?vue&type=template&id=34e07f71&scoped=true"
import script from "./CloseX.vue?vue&type=script&lang=js"
export * from "./CloseX.vue?vue&type=script&lang=js"

import "./CloseX.vue?vue&type=style&index=0&id=34e07f71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e07f71"]])

export default __exports__